<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="获得成就列表" name="user">
                    <User v-if="activeName=='user'"></User>
                </el-tab-pane>
                <el-tab-pane label="成就配置" name="setting">
                    <Setting v-if="activeName=='setting'"></Setting>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import User from './user/Index.vue';
    import Setting from './badge/Index.vue';
    export default {
        components: {
            User,
            Setting,
        },
        data() {
            return {
                activeName: 'user',
                /*是否加载完成*/
                loading: true,
            }
        },
        created() {
            // 默认
            let tabs = this.$db.getRouteField(this, 'tabs');
            if (tabs) this.activeName = tabs;

        },
        methods: {
            /*切换*/
            handleClick(e) {
                this.activeName = e.name;
                this.$db.setRoute(this, {'tabs': e.name});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/study/badge/index.vue